import React, { Component } from 'react'; 
import './App.css';
import QuoteCalc from './steps/Steps';
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      firstStepState: {},
      secondStepState: {},
      thirdStepState: {},
    };
    this.onFlightChange = this.onFlightChange.bind(this);
    // this.onTextChange = this.onTextChange.bind(this);
    this.saveTopState = this.saveTopState.bind(this);
    this.readTopState = this.readTopState.bind(this);

  }
  saveTopState(newTopState, callback) {
    this.setState(newTopState, callback);
  }
  readTopState(topState) {
    return this.state[topState];
  }

  onFlightChange(event) {
    let flights = this.state.flights;
    flights[event.target.name] = event.target.value;
    this.setState({
      flights : flights 
    });
    console.log(this.state.flights)
  }
  // onTextChange(event) {
  //   this.setState({from: event.target.value});

  // }
  onButtonClick(btn) { 
    console.log(this.state.from);
    alert(btn);

  }
  

  render(){
      return (
        <div>
          <div>
            <QuoteCalc 
              saveTopState={this.saveTopState}
              readTopState={this.readTopState}
            />
          </div>

        </div>
  );
}
}




export default App;



// WEBPACK FOOTER //
// ./src/App.js